import { Component, useContext, useMemo, useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { withFormik, Form, useField } from "formik";
import { RestAPI } from "@aws-amplify/api-rest";
import LoadingDialog from "../Utils/LoadingDialog";
import { FormRow, PhoneRow, LocationSubsection, HeaderButtons, callSend } from "../Form/Form";
import {
    validateOptionalRut, validateOptionalDV, validateEmail50, validateString50,
    validatePhone50, validateOptional50, validateOptional75, validateSomething
} from "../../components/Form/Validations";

import "react-toastify/dist/ReactToastify.css";

import { FarmContext } from "../../contexts/FarmContext";
import withName from "../../hoc/withName";
import SelfHelp from "../Utils/SelfHelp";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";
import { isInDateRange } from "../../utils/DataUtils";

const user = "user_form";

const getUser = (location) => {
    if (location.search.search("user") !== -1) {
        const params = new URLSearchParams(location && location.search);
        const user = params.get("user");
        return user;
    } else {
        return null;
    }
};

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

class UserForm extends Component {
    render() {
    //const { resetForm, status = {}, setStatus, data, t, handleSubmit } = this.props;
        const { data, t, i18n, handleSubmit, status, setStatus, canEdit, resetForm, values, errors, touched } = this.props;
        if (!data) return <div className="card col-xl-12 col-lg-12 col-sm-12">No Data</div>;
        const isEdit = canEdit && status.edit;

        const selfHelpImg1 = import.meta.glob("../../img/autoayuda/*/user-add-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/user-add-1.png`];
        const selfHelpImg2 = import.meta.glob("../../img/autoayuda/*/user-add-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/user-add-2.png`];

        return (
            <div className="card">
                <div className="card-body">
                    <Form id={user} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                                <SelfHelp t={t} lng={i18n.language} images={[selfHelpImg1, selfHelpImg2]} />
                            </div>
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title"><span>{t("personal.userInfo")}</span></h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'>
                                {data.is_farm && data.permiso_admin && <HeaderButtons edit={status.edit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={user} />}
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <FormRow
                                    edit={isEdit}
                                    dato1={data.nombre}
                                    nombre1={t("general.name")}
                                    campo1="nombre"
                                    validate1={validateString50}
                                    error1={touched.nombre && errors.nombre && t(errors.nombre)}
                                />
                                <FormRow
                                    edit={isEdit}
                                    dato1={data.apellido_paterno}
                                    nombre1={t("personal.fSurname")}
                                    campo1="apellido_paterno"
                                    validate1={validateString50}
                                    dato2={data.apellido_materno}
                                    nombre2={t("personal.sSurname")}
                                    campo2="apellido_materno"
                                    validate2={validateOptional50}
                                    error1={touched.apellido_paterno && errors.apellido_paterno && t(errors.apellido_paterno)}
                                    error2={touched.apellido_materno && errors.apellido_materno && t(errors.apellido_materno)}
                                />
                                <FormRow
                                    edit={false}
                                    dato1={data.email}
                                    nombre1={t("personal.email")}
                                    campo1="email"
                                    validate1={validateEmail50}
                                    error1={touched.email && errors.email && t(errors.email)}
                                />

                                <PhoneRow
                                    edit={isEdit}
                                    prefix={values.prefix}
                                    dato1={data.telefono_movil}
                                    nombre1={t("personal.phone")}
                                    campo1="telefono_movil"
                                    error1={touched.telefono_movil && errors.telefono_movil && t(errors.telefono_movil)}
                                    dato2={data.telefono_fijo}
                                    nombre2={t("personal.fonoFijo")}
                                    campo2="telefono_fijo"
                                    error2={touched.telefono_fijo && errors.telefono_fijo && t(errors.telefono_fijo)}
                                />

                                <FormRow
                                    edit={isEdit}
                                    dato1={data.direccion}
                                    nombre1={t("personal.address")}
                                    campo1="direccion"
                                    validate1={validateOptional75}
                                    error1={touched.direccion && errors.direccion && t(errors.direccion)}
                                />

                                <LocationSubsection t={t} language={i18n.language}
                                    ubicacion={data.ubicacion} pais={data.pais}
                                    edit={isEdit}
                                    validate={validateSomething} error={touched.pais && errors.pais && t(errors.pais)}
                                />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const formValidate = ({ nombre, apellido_paterno, apellido_materno, email, prefix, telefono_fijo, telefono_movil, direccion, ubicacion }) => {
    const errors = {};
    if (nombre) {
        const er = validateString50(nombre);
        if (er !== undefined) errors.nombre = er;
    }
    if (apellido_paterno) {
        const er = validateString50(apellido_paterno);
        if (er !== undefined) errors.apellido_paterno = er;
    }
    if (apellido_materno) {
        const er = validateOptional50(apellido_materno);
        if (er !== undefined) errors.apellido_materno = er;
    }
    if (email) {
        const er = validateEmail50(email);
        if (er !== undefined) errors.email = er;
    }
    if (telefono_fijo) {
        const er = validatePhone50(prefix ? (prefix + telefono_fijo) : telefono_fijo);
        if (er !== undefined) errors.telefono_fijo = er;
    }
    if (telefono_movil) {
        const er = validatePhone50(prefix ? (prefix + telefono_movil) : telefono_movil);
        if (er !== undefined) errors.telefono_movil = er;
    }
    if (direccion) {
        const er = validateOptional75(direccion);
        if (er !== undefined) errors.direccion = er;
    }
    if (ubicacion) {
        const er = validateSomething(ubicacion);
        if (er !== undefined) errors.ubicacion = er;
    }
    return errors;
};

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return {
            nombre: data.nombre,
            apellido_paterno: data.apellido_paterno,
            apellido_materno: data.apellido_materno,
            email: data.email,
            telefono_movil: data.telefono_movil,
            telefono_fijo: data.telefono_fijo,
            rut: data.rut,
            dv: data.dv,
            tipousuario_id: data.tipousuario_id,
            usuario_id: data.usuario_id,
            prefix: undefined,
            pais: data.pais,
            ubicacion: data.ubicacion,
            direccion: data.direccion
        };
    },
    validate: formValidate,
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        actions.setStatus({ edit: false });
    }
})(withTranslation()(UserForm));

const handleClickBtn = (desde, hasta, setDaysAccess, setShowValidation, lng, farmId, permisoId) => {
    if (desde && hasta) {
        setDaysAccess((state) => {
            return { ...state, loading: true };
        });
        setShowValidation(false);
        hasta.setHours(23, 59, 59, 999);
        const body = {
            desde: desde.toJSON(),
            hasta: hasta.toJSON(),
            lng: lng
        };
        const param = `/users/${farmId}/generalaccess/${permisoId}`;
        RestAPI.post("apiAdminDropControl", param, { body: body })
            .then(res => JSON.parse(JSON.stringify(res)))
            .then((data) => {
                setDaysAccess({
                    loading: false,
                    cant_comentarios: parseInt(data[0].cant_comentarios || 0),
                    cant_riegos: parseInt(data[0].cant_riegos || 0),
                    dias_dc: parseInt(data[0].dias_dc || 0),
                    dias_dc_mobile: parseInt(data[0].dias_dc_mobile || 0)
                });
            }).catch(err => console.error(err));
    } else {
        setShowValidation(true);
    }
};

const CalendarRangePicker = ({ setDaysAccess, t,  lng, farmId, permisoId }) => {
    const [rangeDates, setRangeDates] = useState(null);
    const today = new Date();
    const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    const [showValidation, setShowValidation] = useState(false);
    const [showValidation3M, setShowValidation3M] = useState(false);

    useEffect(() => {

        if(!rangeDates){
            setRangeDates([lastWeek, today]);
        }
        handleClickBtn(lastWeek, today, setDaysAccess, setShowValidation, lng, farmId, permisoId);

    }, [lng, rangeDates, permisoId, farmId]);

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-6 text-md-right mtem-05">
                    <label className="boldie">{t("forms.rangoFechas")}</label>
                </div>
                <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                    <div>
                        <CalendarPrime
                            id="daterangepicker"
                            t={t}
                            maxDaysRange={90}
                            setValue={setRangeDates}
                            value={rangeDates}  onChange={(e) => setRangeDates(e.value)}
                            locale={lng}
                            selectionMode="range"
                            presets
                        />
                    </div>
                </div>
                {showValidation &&
          <div className="col-12 msgRawValidation">
              <span>{t("forms.msgUserAccessValidation")}</span>
          </div>}
                {showValidation3M &&
          <div className="col-12 msgRawValidation">
              <span>{t("forms.msgValidacionRangoFechas3M")}</span>
          </div>}
            </div>
            <div className="row">
                <div className='col-12 mb-4 mt-4 text-center'>
                    <ButtonPrime onClick={() => {
                        const desde = rangeDates && Array.isArray(rangeDates) && rangeDates[0] || null;
                        const hasta = rangeDates && Array.isArray(rangeDates) && rangeDates[1] || null;
                        if (desde && hasta) {
                            if(isInDateRange(desde,hasta,91)){
                                setShowValidation3M(true);
                                setShowValidation(false);
                            }else{
                                handleClickBtn(desde, hasta, setDaysAccess, setShowValidation, lng, farmId, permisoId);
                                setShowValidation3M(false);
                                setShowValidation(false);
                            }
                        }  else {
                            if (!rangeDates?.[1] || !rangeDates?.[0]) {
                                setShowValidation(true);
                                setShowValidation3M(false);
                            }
                        }
                    }} label={t("forms.search")}
                    />
                </div>
            </div>
        </>
    );
};

const User = () => {
    const location = useLocation();
    const permisoId = getUser(location);
    const farmId = getFarm(location);
    const { t, i18n } = useTranslation();
    const [_, dispatch] = useContext(FarmContext);
    const users = dispatch({ type: "get", path: "users" });
    const canEdit = dispatch({ type: "get", path: "canEdit" });
    const acceso_limitado = dispatch({ type: "get", path: "accesoLimitado" });
    const [daysAccess, setDaysAccess] = useState({ loading: false, cant_comentarios: null, cant_riegos: null, dias_dc: null, dias_dc_mobile: null });
    //const [thisUser, setThisUser] = useState({ isLoaded: false })
    const thisUser = useMemo(() => {
        if (!users.data || !Array.isArray(users.data.users)) return;
        const numericPermiso = parseInt(permisoId, 10);
        return users.data.users.find((u) => u && u.permiso_id === numericPermiso);
    }, [users.data, permisoId]);
    /*
    useEffect(() => {
      if (thisUser?.data === undefined && users?.data && Array.isArray(users.data.users) && permisoId) {
        const numericPermiso = parseInt(permisoId, 10);
        const user = users.data.users.find((u) => u && u.permiso_id === numericPermiso);
        setThisUser({ data: user, isLoaded: true });
      }
    }, [users, permisoId, thisUser]);
  */
    useEffect(() => {
        setDaysAccess({ loading: false, cant_comentarios: null, cant_riegos: null, dias_dc: null, dias_dc_mobile: null });
    }, [permisoId, farmId]);

    const selfHelpImgDes1 = import.meta.glob("../../img/autoayuda/*/autoayuda-userRecords-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-userRecords-1.png`];
    const selfHelpImgDes2 = import.meta.glob("../../img/autoayuda/*/autoayuda-userRecords-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-userRecords-2.png`];
    const selfHelpImgDes3 = import.meta.glob("../../img/autoayuda/*/autoayuda-userRecords-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-userRecords-3.png`];
    const selfHelpImgDes4 = import.meta.glob("../../img/autoayuda/*/autoayuda-userRecords-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-userRecords-4.png`];

    const selfHelpTabla = [
        {
            tab: 1, header: { text: t("selfHelp.instructions") }, params:
        [
            { id: 1, text: t("selfHelp.userRecords.msg1"), image: selfHelpImgDes1 },
            { id: 2, text: t("selfHelp.userRecords.msg2"), image: selfHelpImgDes2 },
            { id: 3, text: t("selfHelp.usersRecords.msg3"), image: selfHelpImgDes3 },
            { id: 4, text: t("selfHelp.userRecords.msg4"), image: selfHelpImgDes4 },
        ]
        },
        {
            tab: 2, header: { text: t("selfHelp.definitionsHeader") }, definition: true, params:
        [
            { id: 1, defName: "DropControl: ", defText: t("selfHelp.definitions.dias_dc") },
            { id: 2, defName: "DropControl APP: ", defText: t("selfHelp.definitions.dias_dc_app") },
            { id: 2, defName: `${t("forms.riegosProgramados")}: `, defText: t("selfHelp.definitions.cant_riegos") },
            { id: 2, defName: `${t("forms.comentariosRealizados")}: `, defText: t("selfHelp.definitions.cant_comentarios") }
        ],
        }
    ];

    return (
        <div className='row-container'>
            {users.isLoaded === false && <LoadingDialog />}
            <div className='row'>
                <div className='col-12'>
                    <FormikForm
                        data={thisUser}
                        canEdit={!acceso_limitado && canEdit && thisUser?.is_farm && thisUser?.permiso_admin}
                        updateData={(newData) => callSend(`/users/${farmId}/permission/${permisoId}`, thisUser, newData, t,
                            (record) => dispatch({
                                type: "update", path: "users", params: (info) => {
                                    if (!info || !info.data || !info.data.tipousuario) return;
                                    if (!record.data) return null; // returning null dispatchs a rerender
                                    const users = info.data.users;
                                    const updatedUsers = users ? users.map(u => {
                                        if (u && u.permiso_id && u.permiso_id === record.data.permiso_id) {
                                            return record.data;
                                        }
                                        return u;
                                    }) : [record.data];
                                    return { data: { ...info.data, users: updatedUsers } };
                                }
                            }))}
                    />
                </div>
                <div className='col-12'>
                    <div className='card' id="cardUserAcces">
                        {daysAccess.loading && <LoadingDialog appendTo="self" />}
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4'>
                                    {selfHelpTabla &&
                    <SelfHelp t={t} lng={i18n.language} params={selfHelpTabla} fertiTable />}
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title">
                                        <span>{t("forms.registros")}</span>
                                    </h5>
                                </div>
                            </div>
                            <div className='linea-titulo' />
                            <CalendarRangePicker setDaysAccess={setDaysAccess} t={t} lng={i18n.language} farmId={farmId} permisoId={permisoId} />

                            {daysAccess.dias_dc_mobile !== null &&
                <>
                    <div className="row linea-formulario">
                        <div className="col-12 col-md-6 text-md-right mtem-05">
                            <label className="boldie">{t("forms.accesosDC")}</label>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                            <span>{daysAccess.dias_dc} {t("forms.dias")}</span>
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-12 col-md-6 text-md-right mtem-05">
                            <label className="boldie">{t("forms.accesosDCApp")}</label>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                            <span>{daysAccess.dias_dc_mobile} {t("forms.dias")}</span>
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-12 col-md-6 text-md-right mtem-05">
                            <label className="boldie">{t("forms.riegosProgramados")}</label>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                            <span>{daysAccess.cant_riegos}</span>
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-12 col-md-6 text-md-right mtem-05">
                            <label className="boldie">{t("forms.comentariosRealizados")}</label>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                            <span>{daysAccess.cant_comentarios}</span>
                        </div>
                    </div>
                </>}
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default withName(User, "UserFrag");
